/** Lightweight click telemetry — fires `POST /api/telemetry/click` from
 *  any button/link. Uses `navigator.sendBeacon` so the request survives
 *  the impending page navigation; falls back to `fetch(keepalive:true)`
 *  in the rare browser without beacon support.
 *
 *  Never throws — telemetry failures must not block navigation.
 *  Never blocks on the network — no `await` at the call site.
 */
const API_BASE = process.env.REACT_APP_BACKEND_URL + "/api";

export function trackClick(ctaId, variant = null) {
  try {
    const body = JSON.stringify({ cta_id: ctaId, variant });
    const url = `${API_BASE}/telemetry/click`;
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // Swallow — never let telemetry break navigation.
  }
}
